import React from 'react';
import { render } from 'react-dom';

class EmptyMessage extends React.Component {
    render() {
        return (
            <div className="empty-message">
                { this.props.message }
            </div>
        );
    }

}

export default EmptyMessage;  